import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/api";
import "../components/table.css";
import Pagination from "../components/Pagination";
import Breadcrumbs from "../components/Breadcrumbs";
import Table from "../components/table";
import usePagination from "../utils/usePagination";
import EditNoteIcon from '@mui/icons-material/EditNote';
 
const ChaServicesRequests = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);
 
  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api.get("/cha/request-list");
        setEnquiries(
          Array.isArray(response.data.requests) ? response.data.requests : []
        );
      } catch (error) {
        console.error("Failed to fetch requests:", error);
        setEnquiries([]);
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiries();
  }, []);
 
  const columns = [
    { label: "Enquiry ID", accessor: "enq_id" },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Documents", accessor: "view" },
    {
      label: "Action",
      render: (row) => (
        <Link to={`/audit-details/${row.enq_id}`} >
          {/* View */}
          <EditNoteIcon />
        </Link>
      ),
    },
  ];
 
  return (
    <>
      {loading ? (
        <p>Loading CHA Services Requests...</p>
      ) : (
        <>
          <Breadcrumbs />
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No CHA Services Requests Found"
            itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                totalItems={totalItems}
              />
            }
          />
        </>
      )}
    </>
  );
};
 
export default ChaServicesRequests;
 